import { Input, Renderer2, ElementRef, Output, EventEmitter, OnDestroy, Directive } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
// import * as FormElementModal from '../../modals/form-element.modal'

export interface baseElement {
  form: FormGroup;
  errors: any;
  settings: any;
}

@Directive()
export abstract class FormElementBase implements baseElement, OnDestroy {
  errorMessage: string;
  i: number;
  emitOutput: any[];
  selectedIndex = -1;
  valueSub = new Subscription();

  @Input() form: FormGroup;
  @Input() errors: any;
  @Input() settings: any;

  @Output() inputFocusEvent = new EventEmitter();
  @Output() inputClickEvent = new EventEmitter();
  @Output() inputEnterEvent = new EventEmitter();
  @Output() inputUpdated = new EventEmitter();
  @Output() inputBlurEvent = new EventEmitter();
  @Output() inputKeyupEvent = new EventEmitter();

  constructor() {}

  ngOnInit() {
    this.valueSub.add(
      this.form
        .get(this.settings['formControlName'])
        .valueChanges.subscribe(data => {
          this.settings.value = data;
        })
    );
  }

  valueChange() {
    this.emitOutput = [];
    this.emitOutput.push({
      name: this.settings.name,
      value:
        typeof this.settings.value == 'string'
          ? this.settings.value.trim()
          : this.settings.value
    });
    this.inputUpdated.emit(this.emitOutput);
    if (this.settings['elementName'] == 'select-list') {
      for (const obj of this.settings.innerelements) {
        if (
          obj['value'] === this.form.value[this.settings['formControlName']]
        ) {
          this.selectedIndex = this.settings.innerelements.indexOf(obj);
        }
      }
    }
  }

  ngOnChanges(obj?: any) {
    this.errorMessage = '';
    if (this.errors) {
      for (this.i = 0; this.i < this.errors.length; this.i++) {
        if (this.errors[this.i]['name'] == this.settings.name) {
          if (this.errors[this.i]['isValid'] == false) {
            //this.errorMessage = this.errors[this.i]['error'];
            this.errorMessage = "We apologize for the inconvenience. Services may be slow at the moment, so please wait for a while and try again.";
          } else {
            this.errorMessage = '';
          }
        }
      }
    }
    if (this.settings.value) {
      if (this.form) {
        this.form.controls[this.settings['formControlName']].setValue(
          this.settings.value
        );
        this.emitOutput = [];
        this.emitOutput.push({
          name: this.settings.name,
          value:
            typeof this.settings.value == 'string'
              ? this.settings.value.trim()
              : this.settings.value
        });
        this.inputUpdated.emit(this.emitOutput);
      }
    }

    if (obj.hasOwnProperty('innerElements') || obj.hasOwnProperty('value')) {
      if (this.form && obj.hasOwnProperty('value')) {
        this.form.controls[this.settings['formControlName']].setValue(
          this.settings.value.trim()
        );
        this.valueChange();
      }
    }
  }

  onPaste(e: any, input) {
    e.preventDefault();
  }

  onFocusEvent($event) {
    this.inputFocusEvent.emit($event);
  }

  onClickEvent($event) {
    this.inputClickEvent.emit($event);
  }

  onBlurEvent($event) {
    if (
      this.settings.elementName != 'select-list' &&
      this.settings.elementName != 'radio-button' &&
      this.settings.elementName != 'radio-switch' &&
      this.settings.elementName != 'date-picker' &&
      this.settings.elementName != 'checkbox'
    ) {
      if (this.form.value[this.settings['formControlName']]) {
        if (
          this.settings.type &&
          this.settings.type.toLowerCase() !== 'email'
        ) {
          this.form.controls[this.settings['formControlName']].setValue(
            this.toProperCase(this.form.value[this.settings['formControlName']])
          );
        }
        this.valueChange();
      }
    }
    this.inputBlurEvent.emit($event);
  }

  toProperCase(textVal) {
    return textVal
      .toLowerCase()
      .replace(/^(.)|\s(.)/g, function(textToCaseChange) {
        return textToCaseChange.toUpperCase();
      });
  }

  onEnterEvent($event) {
    this.valueChange();
    this.inputEnterEvent.emit($event);
  }

  onKeyupEvent($event) {
    this.inputKeyupEvent.emit($event);
  }

  ngOnDestroy() {
    this.valueSub.unsubscribe();
  }
}
